import { IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import AvatarMy from "./AvatarMy";
import { jwtDecode } from "jwt-decode";
import { getValueFromPatToken } from "../utils/commonUtils";
import { serviceGetUserBasicInformation } from "../services/patientRegistrationRequesApi";

const pages = ["Products", "Pricing", "Blog"];
const settings = ["Profile", "Logout"];

function PatientHeader() {
  const [firstName, setFirstName] = useState("");
  const navigate = useNavigate();
  const logOut = () => {
    localStorage.removeItem("pat-token");
    localStorage.removeItem("pat-clinic-doctor");
    localStorage.removeItem("clinicName");
    localStorage.removeItem("number");

    //navigate("/patient/familylist");
    navigate(0);
  };

  let decodedToken = getValueFromPatToken("user_id");
  // fetch basic information
  useEffect(() => {
    const fetchUserBasicInfo = async () => {
      try {
        const response = await serviceGetUserBasicInformation(decodedToken);
        const { basicInfo } = response.data;
        setFirstName(basicInfo.first_name);
      } catch (error) {
        console.error("Error fetching basic information:", error);
      }
    };

    fetchUserBasicInfo();
  }, [decodedToken]);

  const openProfile = () => {
    // localStorage.removeItem("pat-token");
    navigate("/patient/profile");
    // navigate(0);
  };

  const handleSettingClick = (setting) => {
    switch (setting) {
      case "Profile":
        openProfile();
        break;
      case "Logout":
        logOut();
        break;
      default:
        handleCloseUserMenu();
        break;
    }
  };

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#fff" }}>
        <Container maxWidth={false}>
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                textDecoration: "none",
              }}
            >
              <img
                src="../images/new_vitalX_logo.png"
                className=" h-12 "
                alt=""
              />
            </Typography>

            <Typography
              variant="h5"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                textDecoration: "none",
              }}
            >
              <img
                src="../images/vitalx_vertial.png"
                className=" h-10 "
                alt=""
              />
            </Typography>
            <Box
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
            ></Box>

            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AvatarMy alt={firstName} src="/broken-image.jpg" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    onClick={() => handleSettingClick(setting)}
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* <div className=" py-2 shadow-md  relative z-10 flex justify-between items-center px-3   hidden">
        <img src="../images/vitalx_vertial.png" className=" h-14 " alt="" />
        <IconButton aria-label="delete" onClick={logOut}>
          <LogoutIcon />
        </IconButton>
      </div> */}
    </>
  );
}

export default PatientHeader;
